import { GenericBackendResponse } from '../../genericBackendResponse';

export interface PayfitCompanyStatus {
	companyId: string;
	companyName: string;
	hasPayfitToken: boolean;
	payfitCompanyId?: string;
}

export interface PayfitCompaniesStatusData {
	companies: PayfitCompanyStatus[];
}

export type GetCompaniesPayfitStatusResponse = GenericBackendResponse<PayfitCompaniesStatusData>;

const getCompaniesPayfitStatus = async (
	token: string
): Promise<GetCompaniesPayfitStatusResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/thirdparty/payfit/companies-status`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error(
			`Failed to fetch companies Payfit status: ${response.status} ${response.statusText}`
		);
	}

	const result: GetCompaniesPayfitStatusResponse = await response.json();
	return result;
};

export default getCompaniesPayfitStatus;
